const data = [
  {
    roles: ["CHRO/HR Leader", "VP Workforce Intelligence"],
    title: "Automated HR Processes",
    asset_title:"Oracle Fusion HCM Analytics ebook",
    description:
      "HR teams rely on up-to-date information to make fast decisions.",
    id: "tbnail-1",
    cta_text: "Read the eBook",
    url: "https://www.oracle.com/a/ocom/docs/oracle-hcm-fusion-analytics-ebook.pdf",
  },
  {
    roles: ["CHRO/HR Leader", "HR Analyst", "VP Talent Acquisition"],
    title: "Top Talent Assessment",
    asset_title:"Oracle Talent Management",
    description:
      "Analysis of compa-ratio bands ensures top performers are compensated appropriately. See the Talent focus product tour",
    id: "tbnail-2",
    cta_text: "Oracle Talent Management Product Tour",
    url: "https://www.oracle.com/webfolder/s/quicktours/hcm/gqt-hcm-talentmgmt/index.html ",
  },
  {
    roles: ["CHRO/HR Leader", "HR Analyst", "VP Talent Acquisition"],
    title: "Top Talent Assessment",
    asset_title:"Impacting Talent Acquisition and Talent Management with Analytics",
    description:
      "For a broader look at all analytics jump to the overall Talent Analytics Product Tour",
    id: "tbnail-3",
    cta_text: "Talent Analytics Product Tour",
    url: "https://www.oracle.com/webfolder/s/quicktours/paas/ba/pt-ba-talentmgmt-analytics/index.html ",
  },
  {
    roles: ["CHRO/HR Leader"],
    title: "D&I Analytics",
    asset_title:"Driving Diversity with Comprehensive Analytics",
    description:
      "Successful D&I efforts require analysis of more than just one or two dimensions of diversity.",
    id: "tbnail-26",
    cta_text: "Read the White Paper",
    url: "https://www.oracle.com/a/ocom/docs/selecthub-driving-diversity-with-comprehensive-analytics-white-paper.pdf",
  },
  {
    roles: ["CHRO/HR Leader"],
    title: "D&I Analytics",
    asset_title:"Synlait directs HR diversity initiatives with Oracle Fusion HCM Analytics",
    description: "Synlait leverages Oracle analytics to improve D&I",
    id: "tbnail-4",
    cta_text: "Customer Story",
    url: "https://www.oracle.com/customers/synlait/ ",
  },
  {
    roles: ["CHRO/HR Leader", "HR IT"],
    title: "Cloud Adoption",
    asset_title:"The State of HR Analytics 2021",
    description:
      "Surround base HR operations with cloud-supported systems and processes.",
    id: "tbnail-5",
    cta_text: "Read the PDF",
    url: "https://www.oracle.com/a/ocom/docs/applications/human-capital-management/hrt-talent-analytics-hrdotcom.pdf ",
  },
  {
    roles: ["CHRO/HR Leader", "HR IT"],
    title: "Cross Departmental",
    asset_title:"Connecting Supply Chain and Workforce Insight to Improve Operational Execution and Flexibility",
    description:
      "A holistic view of HR business and financial strategy is necessary to align workforce investment.",
    id: "tbnail-6",
    cta_text: "Read the Blog",
    url: "https://blogs.oracle.com/analytics/post/connecting-supply-chain-and-workforce-insight-to-improve-operational-execution-and-flexibility",
  },
  {
    roles: ["CHRO/HR Leader", "HR IT"],
    title: "Cross Departmental",
    asset_title:"Combine Finance and HR Insights with Fusion Analytics Warehouse",
    description:
      "Link directly to the overall HCM Analytics product tour with cross departmental examples.",
    id: "tbnail-7",
    cta_text: "Oracle Fusion Analytics for HCM",
    url: "https://www.oracle.com/business-analytics/fusion-hcm-analytics/?ytid=NRdVRMQMigY ",
  },
  {
    roles: ["CHRO/HR Leader"],
    title: "Team Effectiveness",
    asset_title:"Discover Untapped Potential in the Workforce with Analytics",
    description:
      "Assessing team effectiveness goes beyond just individual performance.  See the workforce analytics product tour for additional examples.",
    id: "tbnail-8",
    cta_text: "Workforce Analytics Product Tour",
    url: "https://www.oracle.com/webfolder/s/quicktours/paas/ba/pgqt-ba-pkg-hcm/index.html ",
  },
  {
    roles: ["HR Analyst", "VP Talent Acquisition", "VP Workforce Intelligence"],
    title: "Attrition and Retention",
    asset_title:"Oracle Analytics Product Simulation",
    description:
      "It’s not enough to examine historical attrition data – predict future rates with embedded machine learning.",
    id: "tbnail-9",
    cta_text: "Interactive Demo",
    url: "https://www.oracle.com/explore/hcm-analytics/interactive-hr-attrition/?lb-mode=overlay&source=:ow:o:h:mt:::RC_WWMK210916P00034:NA22_HCM_OC_CO55_M0601_SO005YO01_DO0792_AO01_RO001&intcmp",
  },
  {
    roles: ["HR Analyst", "HR IT"],
    title: "Predictive Analytics",
    asset_title:"Is Your Organization Using the Power of Your People Data?",
    description:
      "Predictive Analytics is becoming a differentiator for HR Analytics customers.",
    id: "tbnail-10",
    cta_text: "View the Infographic",
    url: "https://www.oracle.com/a/ocom/docs/analytics-workday-compete.pdf ",
  },
  {
    roles: ["HR Analyst", "VP Workforce Intelligence", "HR IT"],
    title: "Forecasting Labor Availability",
    asset_title:"Discover Untapped Potential in the Workforce with Analytics",
    description:
      "HR Analytics customers need more than just past trend analysis to ensure they are ahead of the competition.  See additional info in our Workforce Analytics tour.",
    id: "tbnail-11",
    cta_text: "Workforce Analytics Product Tour",
    url: "https://www.oracle.com/webfolder/s/quicktours/paas/ba/pgqt-ba-pkg-hcm/index.html",
  },
  {
    roles: ["HR Analyst", "HR IT"],
    title: "Data Preparation",
    asset_title:"Empowering Line-of-Business Employees with Packaged Analytics Applications",
    description:
      "Reducing your reliance on data scientists for everyday analytical processes allows for faster decision-making.",
    id: "tbnail-12",
    cta_text: "Read the White Paper",
    url: "https://www.oracle.com/a/ocom/docs/ventana-research-packaged-analytics-oracle-white-paper.pdf",
  },
  {
    roles: ["HR Analyst", "HR IT"],
    title: "External Data",
    asset_title:"Discover Untapped Potential in the Workforce with Analytics",
    description:
      "Extension of your HR analysis promotes more accurate benchmarking. See examples of enriching analytics with additional data in the overall HCM product tour.",
    id: "tbnail-13",
    cta_text: "Workforce Analytics Product Tour",
    url: "https://www.oracle.com/webfolder/s/quicktours/paas/ba/pgqt-ba-pkg-hcm/index.html",
  },
  {
    roles: ["HR Analyst", "HR IT"],
    title: "External Data",
    asset_title:"Deliver Forward-looking Insights with Agile HR Analytics",
    description:
      "Focus on extensibility and speed by viewing the agile HR analytics tour.",
    id: "tbnail-14",
    cta_text: "Agile HR Analytics Product Tour",
    url: "https://www.oracle.com/webfolder/s/quicktours/paas/ba/pgqt-ba-analyticsforHR/index.html",
  },
  {
    roles: ["VP Talent Acquisition"],
    title: "Recruiting Effectiveness",
    asset_title:"Oracle Fusion Analytics",
    description:
      "Identifying your most lucrative talent pools can increase hiring effectiveness and streamline the recruiting process.  View the infographic to see why.",
    id: "tbnail-15",
    cta_text: "Infographic",
    url: "https://www.oracle.com/a/ocom/docs/fusion-analytics-warehouse-infographic.pdf",
  },
  {
    roles: ["VP Talent Acquisition"],
    title: "Recruiting Effectiveness",
    asset_title:"Hire the Best and Brightest with Oracle Recruiting",
    description: "Take a quick tour of HCM recruiting.",
    id: "tbnail-16",
    cta_text: "Take the Tour",
    url: "https://www.oracle.com/webfolder/s/quicktours/hcm/pt-hcm-recruiting/index.html?source=:ad:pas:go:eng:a_nas:71700000088380858-58700007477483604-p67203261328:RC_WWMK181223P00012C0001:MainAd",
  },
  {
    roles: ["VP Talent Acquisition"],
    title: "Compensation Trends",
    asset_title:"HR Analytics Plays a Vital Role in the Evolving Workplace",
    description:
      "Take your compa-ratio analysis to the next level with accurate projections and future forecasting.  Read the blog to learn more about the evolving workplace.",
    id: "tbnail-17",
    cta_text: "Read the Blog",
    url: "https://blogs.oracle.com/analytics/post/hr-analytics-plays-a-vital-role-in-the-evolving-workplace",
  },
  {
    roles: ["VP Talent Acquisition", "VP Workforce Intelligence"],
    title: "Career Mobility",
    asset_title:"How to Build a People Analytics Foundation to Create a Healthy, High-performing Company that Scales",
    description:
      "See how to create more opportunities to advance within the organization and retain top talent.",
    id: "tbnail-18",
    cta_text: "Read the Blog",
    url: "https://blogs.oracle.com/analytics/post/how-to-build-a-people-analytics-foundation-to-create-a-healthy-high-performing-company-that-scales",
  },
  {
    roles: ["VP Talent Acquisition"],
    title: "Performance and Goals",
    asset_title:"Impacting Talent Acquisition and Talent Management with Analytics",
    description:
      "Make recommendations automatically based on performance scores vs. goals, see the Talent Analytics product tour for examples.",
    id: "tbnail-20",
    cta_text: "Talent Analytics Product Tour",
    url: "https://www.oracle.com/webfolder/s/quicktours/paas/ba/pt-ba-talentmgmt-analytics/index.html",
  },
  {
    roles: ["VP Workforce Intelligence"],
    title: "Survey Analytics",
    asset_title:"Impacting Talent Acquisition and Talent Management with Analytics",
    description:
      "Assessing employee sentiment provides insights for improvement, see examples in the Talent Analytics tour.",
    id: "tbnail-21",
    cta_text: "Talent Analytics Product Tour",
    url: "https://www.oracle.com/webfolder/s/quicktours/paas/ba/pt-ba-talentmgmt-analytics/index.html",
  },
  {
    roles: ["VP Workforce Intelligence"],
    title: "Survey Analytics",
    asset_title:"Oracle Fusion Analytics for HCM",
    description: "See how Oracle HCM Analytics provides ready-to-use metrics for workforce insights.",
    id: "tbnail-22",
    cta_text: "Learn More",
    url: "https://www.oracle.com/business-analytics/fusion-hcm-analytics/",
  },
  {
    roles: ["VP Workforce Intelligence"],
    title: "Skills Analysis",
    asset_title:"Empower HR with Oracle Fusion HCM Analytics",
    description:
      "Understand the overall skills matrix at your organization and take a more active approach to developing roles and career paths.",
    id: "tbnail-24",
    cta_text: "Learn More",
    url: "https://www.oracle.com/a/ocom/docs/cloud-essentials-empower-business-hcm.pdf ",
  },
  {
    roles: ["VP Workforce Intelligence"],
    title: "Skills Analysis",
    asset_title:"Put People First with Oracle Analytics for Cloud HCM",
    description: "Put people first in your organization, read the blog for more.",
    id: "tbnail-25",
    cta_text: "Read the Blog",
    url: "https://blogs.oracle.com/analytics/post/put-people-first-oracle-analytics-cloud-hcm ",
  },
];

export default data;
